import store from "../../store";

export default {
  canWrite(context) {
    const editor = context.editor;
    let root = null;
    const _store = store.state.contentEditor;

    if (_store) {
      if (editor == "Article") {
        root = _store.article.masterdata[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogNode") {
        root = _store.catalogNode.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "VariationGroup") {
        root = _store.variationGroup.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogTree") {
        root = context;
      }
      if (!editor) {
        console.warn("INVALID Editor:", context.editor, context);
      }
    }
    return !!root?.accessRights?.write;
  },
  canRead(context) {
    const editor = context.editor;
    let root = null;
    const _store = store.state.contentEditor;

    if (_store) {
      if (editor == "Article") {
        root = _store.article.masterdata[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogNode") {
        root = _store.catalogNode.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "VariationGroup") {
        root = _store.variationGroup.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogTree") {
        root = context;
      }
      if (!editor) {
        console.warn("INVALID Editor:", context.editor, context);
      }
      if (!root) {
        console.warn("Root Permission Missing:", _store);
      }
    }
    return !!root?.accessRights?.read;
  },
  canDelete(context) {
    const editor = context.editor;
    let root = null;
    const _store = store.state;

    if (_store) {
      if (editor == "Article") {
        root = _store.article.masterdata[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogNode") {
        root = _store.catalogNode.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "VariationGroup") {
        root = _store.variationGroup.masterData[context.language]?.rootCatalogNode;
      }
      if (editor == "CatalogTree") {
        root = context;
      }
      if (!editor) {
        console.warn("INVALID Editor:", context.editor, context);
      }
      if (!root) {
        console.warn("Root Permission Missing:", _store);
      }
    }
    return !!root?.accessRights?.delete;
  }
};
